export default "__VITE_ASSET__BAk4G0uA__"